import React from "react";
import PropTypes from "prop-types";

// Components
import LoadingSpinner from "../Atoms/LoadingSpinner";
import PageNotFound from "../Pages/PageNotFound";

export const ContentRenderer = ({
  isLoaded,
  isLoading,
  children,
  render404,
}) => {
  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isLoaded && render404) {
    return <PageNotFound />;
  }

  if (isLoaded) {
    return children;
  }

  return null;
};

ContentRenderer.propTypes = {
  isLoaded: PropTypes.bool,
  isLoading: PropTypes.bool,
  children: PropTypes.any.isRequired,
  render404: PropTypes.bool,
};

ContentRenderer.defaultProps = {
  isLoading: false,
  isLoaded: false,
  render404: false,
};

export default ContentRenderer;
